import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import { FadeUp } from "./Reveal";
import { useLang } from "../i18n/i18n";

export function Testimonials() {
  const { t } = useLang();
  const items = t.testimonials.items;
  const rowA = items.slice(0, 3);
  const rowB = items.slice(2).concat(items.slice(0, 2));

  const Card = ({ item }) => (
    <div className="mx-3 w-[320px] shrink-0 border border-white/10 bg-ink2 p-8 transition-colors duration-400 hover:border-crimson/50 sm:w-[420px]">
      <Quote className="h-7 w-7 text-crimson" />
      <p className="mt-5 font-serif text-xl font-light leading-relaxed text-white/85">
        “{item.text}”
      </p>
      <div className="mt-6 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-full border border-crimson/40 font-serif text-lg text-crimson">
          {item.name.charAt(0)}
        </span>
        <div>
          <p className="text-sm text-white">{item.name}</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
            {item.place}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <section
      data-testid="testimonials"
      className="relative overflow-hidden bg-ink py-28 md:py-36"
    >
      <div className="pointer-events-none absolute right-1/4 top-0 h-[400px] w-[400px] rounded-full bg-crimson/10 blur-[150px]" />
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <FadeUp>
          <span className="font-mono text-xs uppercase tracking-[0.28em] text-crimson">
            {t.testimonials.kicker}
          </span>
          <h2 className="mt-5 max-w-3xl font-serif text-4xl font-light leading-tight text-white md:text-6xl">
            {t.testimonials.title}
          </h2>
        </FadeUp>
      </div>

      <div className="mt-16 space-y-5">
        <Marquee speed={35} gradient={false} pauseOnHover autoFill>
          {rowA.map((item, i) => (
            <Card key={i} item={item} />
          ))}
        </Marquee>
        <Marquee speed={35} gradient={false} direction="right" pauseOnHover autoFill>
          {rowB.map((item, i) => (
            <Card key={i} item={item} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}
